import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Employees from '@/pages/Employees';
import Attendance from '@/pages/Attendance';
import BulkAttendance from '@/pages/BulkAttendance';
import SalaryProcess from '@/pages/SalaryProcess';
import SalaryProcessV2 from '@/pages/SalaryProcessV2';
import SalaryProcess1 from '@/pages/SalaryProcess1';
import DownloadMPS from '@/pages/DownloadMPS';
import TransferFunds from '@/pages/TransferFunds';
import SalarySlip from '@/pages/SalarySlip';
import Reports from '@/pages/Reports';
import Approvals from '@/pages/Approvals';
import Payments from '@/pages/Payments';
import Settings from '@/pages/Settings';
import ShiftProAttendance from '@/pages/ShiftProAttendance';
import ShiftProApprovals from '@/pages/ShiftProApprovals';
import ShiftProRosters from '@/pages/ShiftProRosters';
import ShiftProEmployees from '@/pages/ShiftProEmployees';
import ShiftProSettings from '@/pages/ShiftProSettings';
import ShiftProSalarySlip from '@/pages/ShiftProSalarySlip';
import MonthlyGrid2 from '@/pages/MonthlyGrid2';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';

const AccountGuard = ({ user, children }) => {
  if (user?.role === 'Account') {
    toast.error('Sorry, You are not Authorised to access reports other than Transfer Funds');
    return <Navigate to="/transfer-funds" replace />;
  }
  return children;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/"
            element={user ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard user={user} />} />
            <Route path="employees" element={<AccountGuard user={user}><Employees user={user} /></AccountGuard>} />
            <Route path="attendance" element={<AccountGuard user={user}><Attendance user={user} /></AccountGuard>} />
            <Route path="bulk-attendance" element={<AccountGuard user={user}><BulkAttendance user={user} /></AccountGuard>} />
            <Route path="monthly-grid-2" element={<AccountGuard user={user}><MonthlyGrid2 user={user} /></AccountGuard>} />
            <Route path="salary-process" element={<AccountGuard user={user}><SalaryProcess user={user} /></AccountGuard>} />
            <Route path="download-mps" element={user?.role === 'CEO' ? <DownloadMPS /> : <Navigate to="/" replace />} />
            <Route path="salary-process-1" element={user?.role === 'HR' ? <SalaryProcess1 user={user} /> : <Navigate to="/" replace />} />
            <Route path="salary-process-v2" element={<AccountGuard user={user}><SalaryProcessV2 user={user} /></AccountGuard>} />
            <Route path="transfer-funds" element={<TransferFunds user={user} />} />
            <Route path="salary-slips" element={<SalarySlip user={user} />} />
            <Route path="reports" element={<AccountGuard user={user}><Reports user={user} /></AccountGuard>} />
            <Route path="approvals" element={<AccountGuard user={user}><Approvals user={user} /></AccountGuard>} />
            <Route path="payments" element={<AccountGuard user={user}><Payments user={user} /></AccountGuard>} />
            <Route path="settings" element={<AccountGuard user={user}><Settings user={user} /></AccountGuard>} />
            <Route path="shiftpro-attendance" element={<AccountGuard user={user}><ShiftProAttendance user={user} /></AccountGuard>} />
            <Route path="shiftpro-approvals" element={<AccountGuard user={user}><ShiftProApprovals user={user} /></AccountGuard>} />
            <Route path="shiftpro-rosters" element={<AccountGuard user={user}><ShiftProRosters user={user} /></AccountGuard>} />
            <Route path="shiftpro-employees" element={<AccountGuard user={user}><ShiftProEmployees user={user} /></AccountGuard>} />
            <Route path="shiftpro-settings" element={<AccountGuard user={user}><ShiftProSettings user={user} /></AccountGuard>} />
            <Route path="shiftpro-salary-slip" element={<ShiftProSalarySlip user={user} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
